module.exports = __webpack_public_path__ + "img/privilege14.e80951a0.png";